import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { useState } from "react";
import { GoDotFill } from "react-icons/go";
import benefit1 from "./images/benefit1.png";
import benefit2 from "./images/benefit2.png";
import benefit3 from "./images/benefit3.png";
import sdg15 from "./images/E-WEB-Goal-15.png";
import sdg14 from "./images/E-WEB-Goal-14.png";
import sdg13 from "./images/E-WEB-Goal-13.png";
//import sdg5 from "./images/E-WEB-Goal-5.png";
//import sdg1 from "./images/E-WEB-Goal-1.png";

const CoBenifitsCertificationsCard = () => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value: any) => setOpen(open === value ? 0 : value);

  const Icon = ({ id, open }: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open
            ? "h-7 w-7 rotate-180 scale-100 rounded-full bg-[#482F8B33] p-1 text-[#482F8B]"
            : ""
        } h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    );
  };

  const CoBenifitsCertifications = [
    {
      title: "Benefit Sharing",
      content: "Community-driven mangrove conservation initiatives",
      projectActivity: [
        "Direct employment opportunities for local community members in mangrove restoration in nurseries",
        "Income generation through sustainable fishing and aquaculture practices",
        "Capacity building workshops for sustainable resource management",
        "Knowledge sharing between traditional fishing communities",
        "Support for alternative livelihoods through eco-tourism",
      ],
      images: [benefit1, benefit2, benefit3],
    },
    {
      title: "Climate Justice",
      content: "Equitable climate action through mangrove conservation",
      projectActivity: [
        "Coastal protection against rising sea levels and extreme weather events",
        "Support for vulnerable coastal communities in adaptation strategies",
        "Fair distribution of conservation benefits across community groups",
        "Preservation of traditional fishing grounds and indigenous practices",
        "Enhanced food security through sustainable coastal management",
      ],
      // images: [jungle, jungle2, jungle3],
    },
    {
      title: "People Leadership & engagement",
      content: "Local community empowerment and leadership development",
      projectActivity: [
        "Formation and training of local mangrove management committees",
        "Regular stakeholder meetings and participatory decision-making",
        "Youth engagement in conservation and monitoring activities",
        "Women's leadership in mangrove nursery management",
        "Collaboration with local schools for environmental education",
      ],
      // images: [jungle, jungle2, jungle3],
    },
    {
      title: "People contribution to SDGs",
      content: "Supporting multiple Sustainable Development Goals",
      projectActivity: [
        "SDG 13: Carbon sequestration through mangrove protection",
        "SDG 14: Conservation of marine biodiversity and fish habitats",
        "SDG 15: Protection of coastal ecosystems and biodiversity",
        "SDG 1: Poverty reduction through sustainable livelihoods",
        "SDG 5: Gender equality in conservation leadership",
      ],
      images: [sdg13, sdg14, sdg15],
    },
  ];

  return (
    <div className="max-w-full rounded-lg bg-white shadow-md">
      <h3 className="p-4 text-lg font-medium">
        Co benefit certifications and Project activities needed
      </h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="p-4">
        {CoBenifitsCertifications.map((item, index) => {
          return (
            <Accordion
              key={index}
              placeholder={""}
              open={open === index}
              icon={<Icon id={index} open={open} />}
            >
              <AccordionHeader
                placeholder={""}
                onClick={() => handleOpen(index)}
                className="text-md font-primary font-medium"
              >
                {item.title}
              </AccordionHeader>
              <AccordionBody className="font-primary">
                <div>{item.content}</div>
                <div className="my-4">
                  <h2 className="my-1 font-medium text-black">Project Activity</h2>
                  {item.projectActivity.map((activity, index) => {
                    return (
                      <p key={index} className="flex items-center gap-2 space-y-1">
                        <GoDotFill className="text-black" />
                        <span>{activity}</span>
                      </p>
                    );
                  })}
                </div>
                <div className="grid grid-cols-3 gap-4 overflow-x-auto">
                  {item.images &&
                    item.images.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt="image"
                        className="mr-4 max-h-36 w-full basis-1/3 rounded-lg object-cover"
                      />
                    ))}
                </div>
              </AccordionBody>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};

export default CoBenifitsCertificationsCard;
